import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { TradeInApi } from "../../../services";

const getQueryFn = () => {
  try {
    const tradeInApi = new TradeInApi();
    return () => tradeInApi.getTradeInEligibility();
  } catch {
    return () => Promise.reject();
  }
};

export const useGetTradeInEligibility = (enabled: boolean = true) => {
  return useQuery([QUERY_KEYS.tradeInEligibility], {
    queryFn: getQueryFn(),
    enabled,
  });
};
